import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import ServicePage from "@/pages/ServicePage";
import SellYourCar from "@/pages/SellYourCar";
import Faq from "@/pages/Faq";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Areas from "@/pages/Areas";
import SuburbPage from "@/pages/SuburbPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import AuthCallback from "@/pages/admin/AuthCallback";

const SERVICES = ["used-cars", "unwanted-cars", "scrap-cars", "old-cars", "junk-cars", "car-removals"];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/sell-your-car" element={<SellYourCar />} />
        {SERVICES.map((s) => <Route key={s} path={`/${s}`} element={<ServicePage slug={s} />} />)}
        <Route path="/faq" element={<Faq />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/areas" element={<Areas />} />
        <Route path="/areas/:slug" element={<SuburbPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin" element={<Login />} />
      <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
